<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <div class="header-form">
          <!-- 表单 -->
          <el-form :inline="true" :model="queryParams" class="demo-form-inline">
            <el-form-item label="姓名">
              <el-input
                @change="searchList"
                clearable
                v-model="queryParams.fullname"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input
                @change="searchList"
                clearable
                v-model="queryParams.mobile"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item label="确认时间">
              <el-date-picker
                @change="handleChangeTime"
                v-model="queryParams.time"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item> -->
          </el-form>
          <div>
            <el-button type="primary" @click="addRecord" style="width:80px"
              >新建</el-button
            >
            <el-button type="primary" @click="handleExport" style="width:80px"
              >导出</el-button
            >
          </div>
        </div>
        <!-- 列表 -->
        <el-table
          :height="tableHeight"
          v-loading="loading"
          :data="tableData"
          style="width: 100%;margin-top: 20px;"
        >
          <el-table-column
            align="center"
            show-overflow-tooltip
            type="index"
            width="50"
            label="序号"
          >
          </el-table-column>
          <el-table-column
            align="center"
            show-overflow-tooltip
            prop="fullname"
            label="姓名"
          >
          </el-table-column>
          <el-table-column
            align="center"
            show-overflow-tooltip
            prop="mobile"
            label="手机号"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="link"
            label="链接"
          >
            <template slot-scope="scope">
              <div slot="reference" class="name-wrapper">
                  <span id="textValue">{{ `${baseUrl}/#/pages/sale/reg?user_id=` +
                    scope.row.id }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            show-overflow-tooltip
            prop="number"
            label="成功数量"
          >
          </el-table-column>
          <el-table-column
            align="center"
            show-overflow-tooltip
            label="操作"
            fixed="right"
            width="200px"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                style="width:80px"
                @click="handeleDelete(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="page-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            :current-page="1"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          >
          </el-pagination>
        </div>
      </div>
    </PageHeaderLayout>
    <!-- 弹框 -->
    <el-dialog
      title="新建用户"
      :visible.sync="dialogVisible"
      width="30%"
      center
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="姓名" prop="fullname">
          <el-input
            clearable
            type="text"
            v-model="ruleForm.fullname"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input
            clearable
            type="text"
            v-model="ruleForm.mobile"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
export default {
  components: {
    PageHeaderLayout,
  },
  data() {
    return {
      tableHeight: 600,
      baseUrl:'https://h5.khl.top',
      loading:false,
      total: null,
      dialogVisible: false,
      queryParams: {
        fullname: null,
        mobile: null,
        time: null,
        start_time: null,
        end_time: null,
      },
      ruleForm: {
        fullname: "",
        mobile: "",
      },
      rules: {
        fullname: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            min: 11,
            max: 11,
            message: "请输入11位手机号",
            trigger: "blur",
          },
        ],
      },
      tableData: [],
    };
  },
  mounted() {
    this.getList();
    this.getTableHeight();
    window.addEventListener('resize', () => { this.getTableHeight()})
  },
  methods: {
    // 获取列表
    async getList() {
      this.loading = true
      if (this.queryParams.time) {
        this.queryParams.start_time = this.queryParams.time[0];
        this.queryParams.end_time = this.queryParams.time[1];
      }
      delete this.queryParams.time;
      const res = await this.$api.getShareRegisterList(this.queryParams);
      this.tableData = res.data;
      this.total = res.pages.total;
      this.loading = false
    },
    // 搜索查询
    searchList(){
      this.queryParams.current_page = 1
      this.getList()
    },
    //计算table高度(动态设置table高度)
    getTableHeight() {
      let tableH = 507; //距离页面下方的高度
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 300) {
        this.tableHeight = 300;
      } else {
        this.tableHeight = window.innerHeight - tableH;
      }
    },
    // 切换时间
    handleChangeTime() {
      if (this.queryParams.time) {
        this.getList();
      } else {
        this.queryParams.start_time = null;
        this.queryParams.end_time = null;
        this.getList();
      }
    },
    // 导出
    async handleExport() {
      const res = await this.$api.getShareRegisterList({ page_size: 99999 });
      let list = res.data;
      let bookType = "xlsx";
      import("@/excel/Export2Excel").then((excel) => {
        let tHeader = ["姓名", "手机号", "链接", "成功数量"];
        const data = this.formatJson(list);
        const time = new Date().getTime() + Math.random() * 1000;
        let filename = `${time}`;
        excel.export_json_to_excel({
          header: tHeader, //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: bookType, //Optional
        });
      });
    },
    // 格式化数据
    formatJson(jsonData) {
      return jsonData.map((item) => {
        return [
          item.fullname,
          item.mobile,
          `${this.baseUrl}/#/pages/sale/reg?user_id=` + item.id,
          item.number,
        ];
      });
    },
    // 格式化列表
    formatterName(row) {
      if (row.user) {
        return row.user.fullname;
      }
    },
    formatterMobile(row) {
      if (row.user) {
        return row.user.mobile;
      }
    },
    handeleDelete(id) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.$api.deleteSalesPerson(id);
          this.getList()
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange(size) {
      this.queryParams.page_size = size;
      this.getList();
    },
    handleCurrentChange(page) {
      this.queryParams.current_page = page;
      this.getList();
    },
    // 新增记录
    addRecord() {
      this.ruleForm = {
        fullname: "",
        mobile: "",
      };
      this.dialogVisible = true;
    },
    // 提交
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const res = await this.$api.addShareSales(this.ruleForm);
          console.log(res);
          this.dialogVisible = false;
          this.$refs[formName].resetFields();
          this.getList();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.ruleForm = {
        name: "",
        mobile: "",
      };
      this.$refs.ruleForm.clearValidate();
    },
    // 关闭
    cancel(formName) {
      this.dialogVisible = false;
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
.main-page-content {
  margin-top: 20px;
  min-width: 1200px;
  .header-form {
    display: flex;
    justify-content: space-between;
  }
  .page-box {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
